module.exports = __webpack_public_path__ + "static/media/Heneritta Bullard Wardrobes (12).155cc8e4.jpg";